import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutTestimonialSliderLarge = {
  factory: EElement({
    id: '60dbc9e2-6469-807c-eee9-6ea92710f6fb',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('b0513dc0-6641-dcb3-95c4-4bd7bfe52777')]),
      children: EList([
        EElement({
          id: '67e7eda8-fd88-ce61-9009-4cb80bd4017e',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '9da4af75-dc42-d128-3ea1-094fc08fb9c8',
                type: qualify(
                  Plugins.name('Slider'),
                  Component.name('SliderWrapper')
                ),
                data: ERecord({
                  slider: ERecord({
                    navSpacing: ENumber(12),
                    navShadow: EBoolean(false),
                    autoplay: EBoolean(false),
                    delay: ENumber(4000),
                    iconArrows: EBoolean(true),
                    animation: EEnum('slide'),
                    navNumbers: EBoolean(false),
                    easing: EEnum('ease'),
                    navRound: EBoolean(true),
                    hideArrows: EBoolean(false),
                    disableSwipe: EBoolean(false),
                    duration: ENumber(500),
                    infinite: EBoolean(true),
                    autoMax: ENumber(0),
                    navInvert: EBoolean(true),
                    type: EText('wrapper'),
                  }),
                  styleBlockIds: EList([
                    EText('a8c0f2c2-e3ce-677e-dcfd-5a2e96bf4c30'),
                  ]),
                  children: EList([
                    EElement({
                      id: '9da4af75-dc42-d128-3ea1-094fc08fb9c9',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderMask')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          type: EText('slides'),
                        }),
                        children: EList([
                          EElement({
                            id: '9da4af75-dc42-d128-3ea1-094fc08fb9ca',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('slide'),
                              }),
                              children: EList([
                                EElement({
                                  id: '19ae0f96-cd13-e87c-96fa-3285785cb1cc',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '1bfb17d0-2cde-7a6f-6bd5-65867137f927'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '8bd98675-a96f-b823-f31f-36e5a4538b73',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              'b86ef35d-5456-df56-a13f-511076b37cc3'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '5f90e485-1981-4b78-c730-bd8fe4a15a1b',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  src: EText(
                                                    images.doubleQuoteBlockLight
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  alt: EText(
                                                    '__wf_reserved_decorative'
                                                  ),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"627311a99765baa36e654ea6"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '9173a8fc-d0c3-9020-b2c6-529e65515d78'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                            EElement({
                                              id: '765a6102-8973-3831-2e01-7ecc02cd41ab',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                text: EBoolean(true),
                                                tag: EEnum('div'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'cce71f35-76a3-8ec1-93bd-80e834df5abe'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '765a6102-8973-3831-2e01-7ecc02cd41ac',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros.'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '5a52de8b-c5b0-e981-134c-5cd3608febd3',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'c45069b3-fc3f-b87d-4ce4-6617c9174f38'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '8d6f3f7c-03ae-5717-1992-e92da0d39898',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Image')
                                                    ),
                                                    data: ERecord({
                                                      attr: ERecord({
                                                        src: EText(
                                                          images.placeholderImageHills
                                                        ),
                                                        loading: EEnum('lazy'),
                                                        width: EText('auto'),
                                                        height: EText('auto'),
                                                        alt: EText(
                                                          '__wf_reserved_inherit'
                                                        ),
                                                      }),
                                                      img: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Asset'),
                                                          typeName('Image')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"id":"627311a99765baa36e654e9a"}'
                                                        ),
                                                      }),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          'eee554db-e006-8dc8-ae3d-0f25db8d5e13'
                                                        ),
                                                      ]),
                                                      temp: ERecord({
                                                        img: ERecord({
                                                          src: EText(''),
                                                        }),
                                                      }),
                                                      srcsetDisabled:
                                                        EBoolean(false),
                                                      sizes: EList([]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: '5a52de8b-c5b0-e981-134c-5cd3608febd5',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('div'),
                                                      text: EBoolean(false),
                                                      children: EList([
                                                        EElement({
                                                          id: '5a52de8b-c5b0-e981-134c-5cd3608febd6',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'Block'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            text: EBoolean(
                                                              true
                                                            ),
                                                            tag: EEnum('div'),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  '67a6bd26-47c6-6cd9-a2d9-4943d79f7131'
                                                                ),
                                                              ]),
                                                            children: EList([
                                                              EElement({
                                                                id: '5a52de8b-c5b0-e981-134c-5cd3608febd7',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'Author Name'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                        EElement({
                                                          id: '5a52de8b-c5b0-e981-134c-5cd3608febd8',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'Block'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            text: EBoolean(
                                                              true
                                                            ),
                                                            tag: EEnum('div'),
                                                            children: EList([
                                                              EElement({
                                                                id: '5a52de8b-c5b0-e981-134c-5cd3608febd9',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'VP of Company'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'd0518541-88f1-f929-f467-416d7b1f0861',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Image')
                                        ),
                                        data: ERecord({
                                          attr: ERecord({
                                            src: EText(
                                              images.placeholderImageGallery
                                            ),
                                            loading: EEnum('lazy'),
                                            width: EText('auto'),
                                            height: EText('auto'),
                                            alt: EText('__wf_reserved_inherit'),
                                          }),
                                          img: ELiteral({
                                            name: qualify(
                                              Plugins.name('Asset'),
                                              typeName('Image')
                                            ),
                                            value: JSON.parse(
                                              '{"id":"627311a99765baa36e654e9d"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '51048331-6acb-a80d-2a7c-788e4ab28cdb'
                                            ),
                                          ]),
                                          temp: ERecord({
                                            img: ERecord({
                                              src: EText(''),
                                            }),
                                          }),
                                          srcsetDisabled: EBoolean(false),
                                          sizes: EList([]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '9da4af75-dc42-d128-3ea1-094fc08fb9cb',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('slide'),
                              }),
                              children: EList([
                                EElement({
                                  id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7ce',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '1bfb17d0-2cde-7a6f-6bd5-65867137f927'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7cf',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              'b86ef35d-5456-df56-a13f-511076b37cc3'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7d0',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  src: EText(
                                                    images.doubleQuoteBlockLight
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"627311a99765baa36e654ea6"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '9173a8fc-d0c3-9020-b2c6-529e65515d78'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                            EElement({
                                              id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7d1',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                text: EBoolean(true),
                                                tag: EEnum('div'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'cce71f35-76a3-8ec1-93bd-80e834df5abe'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7d2',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      "Lorem Ipsum is simply dummy of the printing and typesetting industry. Lorem Ipsum has been the industry's."
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7d3',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'c45069b3-fc3f-b87d-4ce4-6617c9174f38'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7d4',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Image')
                                                    ),
                                                    data: ERecord({
                                                      attr: ERecord({
                                                        src: EText(
                                                          images.placeholderImageHills
                                                        ),
                                                        loading: EEnum('lazy'),
                                                        width: EText('auto'),
                                                        height: EText('auto'),
                                                        alt: EText(
                                                          '__wf_reserved_inherit'
                                                        ),
                                                      }),
                                                      img: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Asset'),
                                                          typeName('Image')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"id":"627311a99765baa36e654e9a"}'
                                                        ),
                                                      }),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '343f9f95-7390-75b6-5465-86d52e0c6786'
                                                        ),
                                                      ]),
                                                      temp: ERecord({
                                                        img: ERecord({
                                                          src: EText(''),
                                                        }),
                                                      }),
                                                      srcsetDisabled:
                                                        EBoolean(false),
                                                      sizes: EList([]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7d5',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('div'),
                                                      text: EBoolean(false),
                                                      children: EList([
                                                        EElement({
                                                          id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7d6',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'Block'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            text: EBoolean(
                                                              true
                                                            ),
                                                            tag: EEnum('div'),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  '67a6bd26-47c6-6cd9-a2d9-4943d79f7131'
                                                                ),
                                                              ]),
                                                            children: EList([
                                                              EElement({
                                                                id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7d7',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'Author Name'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                        EElement({
                                                          id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7d8',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'Block'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            text: EBoolean(
                                                              true
                                                            ),
                                                            tag: EEnum('div'),
                                                            children: EList([
                                                              EElement({
                                                                id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7d9',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'VP of Company'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '7f8be3e4-c93b-36e1-3592-fb2ddebab7da',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Image')
                                        ),
                                        data: ERecord({
                                          attr: ERecord({
                                            src: EText(
                                              images.placeholderImageGallery
                                            ),
                                            loading: EEnum('lazy'),
                                            width: EText('auto'),
                                            height: EText('auto'),
                                            alt: EText('__wf_reserved_inherit'),
                                          }),
                                          img: ELiteral({
                                            name: qualify(
                                              Plugins.name('Asset'),
                                              typeName('Image')
                                            ),
                                            value: JSON.parse(
                                              '{"id":"627311a99765baa36e654e9d"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '51048331-6acb-a80d-2a7c-788e4ab28cdb'
                                            ),
                                          ]),
                                          temp: ERecord({
                                            img: ERecord({
                                              src: EText(''),
                                            }),
                                          }),
                                          srcsetDisabled: EBoolean(false),
                                          sizes: EList([]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd1e61679-fa8d-61da-71b7-61cb6af2e79f',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('Slider'),
                              }),
                              children: EList([
                                EElement({
                                  id: 'a1a927ca-f423-be18-2ff3-5636982fb384',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '1bfb17d0-2cde-7a6f-6bd5-65867137f927'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'a1a927ca-f423-be18-2ff3-5636982fb385',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              'b86ef35d-5456-df56-a13f-511076b37cc3'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'a1a927ca-f423-be18-2ff3-5636982fb386',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  src: EText(
                                                    images.doubleQuoteBlockLight
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"627311a99765baa36e654ea6"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '9173a8fc-d0c3-9020-b2c6-529e65515d78'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'a1a927ca-f423-be18-2ff3-5636982fb387',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                text: EBoolean(true),
                                                tag: EEnum('div'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'cce71f35-76a3-8ec1-93bd-80e834df5abe'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'a1a927ca-f423-be18-2ff3-5636982fb388',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      "Lorem Ipsum is simply dummy of the printing and typesetting industry. Lorem Ipsum has been the industry's."
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'a1a927ca-f423-be18-2ff3-5636982fb389',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'c45069b3-fc3f-b87d-4ce4-6617c9174f38'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'a1a927ca-f423-be18-2ff3-5636982fb38a',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Image')
                                                    ),
                                                    data: ERecord({
                                                      attr: ERecord({
                                                        src: EText(
                                                          images.placeholderImageHills
                                                        ),
                                                        loading: EEnum('lazy'),
                                                        width: EText('auto'),
                                                        height: EText('auto'),
                                                        alt: EText(
                                                          '__wf_reserved_inherit'
                                                        ),
                                                      }),
                                                      img: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Asset'),
                                                          typeName('Image')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"id":"627311a99765baa36e654e9a"}'
                                                        ),
                                                      }),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '343f9f95-7390-75b6-5465-86d52e0c6786'
                                                        ),
                                                      ]),
                                                      temp: ERecord({
                                                        img: ERecord({
                                                          src: EText(''),
                                                        }),
                                                      }),
                                                      srcsetDisabled:
                                                        EBoolean(false),
                                                      sizes: EList([]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: 'a1a927ca-f423-be18-2ff3-5636982fb38b',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('div'),
                                                      text: EBoolean(false),
                                                      children: EList([
                                                        EElement({
                                                          id: 'a1a927ca-f423-be18-2ff3-5636982fb38c',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'Block'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            text: EBoolean(
                                                              true
                                                            ),
                                                            tag: EEnum('div'),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  '67a6bd26-47c6-6cd9-a2d9-4943d79f7131'
                                                                ),
                                                              ]),
                                                            children: EList([
                                                              EElement({
                                                                id: 'a1a927ca-f423-be18-2ff3-5636982fb38d',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'Author Name'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                        EElement({
                                                          id: 'a1a927ca-f423-be18-2ff3-5636982fb38e',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'Block'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            text: EBoolean(
                                                              true
                                                            ),
                                                            tag: EEnum('div'),
                                                            children: EList([
                                                              EElement({
                                                                id: 'a1a927ca-f423-be18-2ff3-5636982fb38f',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'VP of Company'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'a1a927ca-f423-be18-2ff3-5636982fb390',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Image')
                                        ),
                                        data: ERecord({
                                          attr: ERecord({
                                            src: EText(
                                              images.placeholderImageGallery
                                            ),
                                            loading: EEnum('lazy'),
                                            width: EText('auto'),
                                            height: EText('auto'),
                                            alt: EText('__wf_reserved_inherit'),
                                          }),
                                          img: ELiteral({
                                            name: qualify(
                                              Plugins.name('Asset'),
                                              typeName('Image')
                                            ),
                                            value: JSON.parse(
                                              '{"id":"627311a99765baa36e654e9d"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '51048331-6acb-a80d-2a7c-788e4ab28cdb'
                                            ),
                                          ]),
                                          temp: ERecord({
                                            img: ERecord({
                                              src: EText(''),
                                            }),
                                          }),
                                          srcsetDisabled: EBoolean(false),
                                          sizes: EList([]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '24ced75a-0bac-ec09-6cd6-02818b9a8c64',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('Slider'),
                              }),
                              children: EList([
                                EElement({
                                  id: '95c1d3d8-f207-a85d-9b4d-1555f2736d28',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '1bfb17d0-2cde-7a6f-6bd5-65867137f927'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '95c1d3d8-f207-a85d-9b4d-1555f2736d29',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              'b86ef35d-5456-df56-a13f-511076b37cc3'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '95c1d3d8-f207-a85d-9b4d-1555f2736d2a',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  src: EText(
                                                    images.doubleQuoteBlockLight
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"627311a99765baa36e654ea6"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '9173a8fc-d0c3-9020-b2c6-529e65515d78'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                            EElement({
                                              id: '95c1d3d8-f207-a85d-9b4d-1555f2736d2b',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                text: EBoolean(true),
                                                tag: EEnum('div'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'cce71f35-76a3-8ec1-93bd-80e834df5abe'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '95c1d3d8-f207-a85d-9b4d-1555f2736d2c',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      "Lorem Ipsum is simply dummy of the printing and typesetting industry. Lorem Ipsum has been the industry's."
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '95c1d3d8-f207-a85d-9b4d-1555f2736d2d',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'c45069b3-fc3f-b87d-4ce4-6617c9174f38'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '95c1d3d8-f207-a85d-9b4d-1555f2736d2e',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Image')
                                                    ),
                                                    data: ERecord({
                                                      attr: ERecord({
                                                        src: EText(
                                                          images.placeholderImageHills
                                                        ),
                                                        loading: EEnum('lazy'),
                                                        width: EText('auto'),
                                                        height: EText('auto'),
                                                        alt: EText(
                                                          '__wf_reserved_inherit'
                                                        ),
                                                      }),
                                                      img: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Asset'),
                                                          typeName('Image')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"id":"627311a99765baa36e654e9a"}'
                                                        ),
                                                      }),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '343f9f95-7390-75b6-5465-86d52e0c6786'
                                                        ),
                                                      ]),
                                                      temp: ERecord({
                                                        img: ERecord({
                                                          src: EText(''),
                                                        }),
                                                      }),
                                                      srcsetDisabled:
                                                        EBoolean(false),
                                                      sizes: EList([]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: '95c1d3d8-f207-a85d-9b4d-1555f2736d2f',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('div'),
                                                      text: EBoolean(false),
                                                      children: EList([
                                                        EElement({
                                                          id: '95c1d3d8-f207-a85d-9b4d-1555f2736d30',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'Block'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            text: EBoolean(
                                                              true
                                                            ),
                                                            tag: EEnum('div'),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  '67a6bd26-47c6-6cd9-a2d9-4943d79f7131'
                                                                ),
                                                              ]),
                                                            children: EList([
                                                              EElement({
                                                                id: '95c1d3d8-f207-a85d-9b4d-1555f2736d31',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'Author Name'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                        EElement({
                                                          id: '95c1d3d8-f207-a85d-9b4d-1555f2736d32',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'Block'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            text: EBoolean(
                                                              true
                                                            ),
                                                            tag: EEnum('div'),
                                                            children: EList([
                                                              EElement({
                                                                id: '95c1d3d8-f207-a85d-9b4d-1555f2736d33',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'VP of Company'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '95c1d3d8-f207-a85d-9b4d-1555f2736d34',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Image')
                                        ),
                                        data: ERecord({
                                          attr: ERecord({
                                            src: EText(
                                              images.placeholderImageGallery
                                            ),
                                            loading: EEnum('lazy'),
                                            width: EText('auto'),
                                            height: EText('auto'),
                                            alt: EText('__wf_reserved_inherit'),
                                          }),
                                          img: ELiteral({
                                            name: qualify(
                                              Plugins.name('Asset'),
                                              typeName('Image')
                                            ),
                                            value: JSON.parse(
                                              '{"id":"627311a99765baa36e654e9d"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '51048331-6acb-a80d-2a7c-788e4ab28cdb'
                                            ),
                                          ]),
                                          temp: ERecord({
                                            img: ERecord({
                                              src: EText(''),
                                            }),
                                          }),
                                          srcsetDisabled: EBoolean(false),
                                          sizes: EList([]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '9da4af75-dc42-d128-3ea1-094fc08fb9cc',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderArrow')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          dir: EText('left'),
                        }),
                        styleBlockIds: EList([
                          EText('b6d8f8f1-84db-70ec-8ae1-d309a3af6d67'),
                        ]),
                        children: EList([
                          EElement({
                            id: '9da4af75-dc42-d128-3ea1-094fc08fb9cd',
                            type: qualify(
                              Plugins.name('Icon'),
                              Component.name('Icon')
                            ),
                            data: ERecord({
                              widget: ERecord({
                                type: EText('icon'),
                                icon: EText('slider-left'),
                              }),
                              children: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '9da4af75-dc42-d128-3ea1-094fc08fb9ce',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderArrow')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          dir: EText('right'),
                        }),
                        styleBlockIds: EList([
                          EText('b6d8f8f1-84db-70ec-8ae1-d309a3af6d67'),
                        ]),
                        children: EList([
                          EElement({
                            id: '9da4af75-dc42-d128-3ea1-094fc08fb9cf',
                            type: qualify(
                              Plugins.name('Icon'),
                              Component.name('Icon')
                            ),
                            data: ERecord({
                              widget: ERecord({
                                type: EText('icon'),
                                icon: EText('slider-right'),
                              }),
                              children: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '9da4af75-dc42-d128-3ea1-094fc08fb9d0',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderNav')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          type: EText('nav'),
                        }),
                        styleBlockIds: EList([
                          EText('6919bf98-36ff-8d4d-a618-b341380a42ab'),
                        ]),
                        children: EList([]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: 'b0513dc0-6641-dcb3-95c4-4bd7bfe52777',
      type: 'class',
      name: 'Testimonial Slider Large',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: 'a8c0f2c2-e3ce-677e-dcfd-5a2e96bf4c30',
      type: 'class',
      name: 'Testimonial Slider Two',
      comb: '',
      styleLess: 'height: auto; background-color: transparent;',
      children: [],
      variants: {},
    },
    {
      _id: '1bfb17d0-2cde-7a6f-6bd5-65867137f927',
      type: 'class',
      name: 'Testimonial Slide',
      comb: '',
      styleLess:
        'display: flex; padding-top: 12px; padding-right: 12px; padding-bottom: 12px; padding-left: 64px; justify-content: space-between; align-items: center; background-color: hsla(0, 0.00%, 100.00%, 1.00);',
      children: [],
      variants: {
        medium: {styleLess: 'padding-left: 32px;'},
        small: {
          styleLess:
            'padding-top: 23px; padding-right: 23px; padding-bottom: 23px; padding-left: 23px; flex-direction: column;',
        },
      },
    },
    {
      _id: 'b86ef35d-5456-df56-a13f-511076b37cc3',
      type: 'class',
      name: 'Testimonial Content',
      comb: '',
      styleLess:
        'display: flex; max-width: 460px; margin-right: 40px; flex-direction: column; align-items: flex-start;',
      children: [],
      variants: {
        small: {
          styleLess: 'max-width: none; margin-right: 0px; margin-bottom: 40px;',
        },
      },
    },
    {
      _id: '9173a8fc-d0c3-9020-b2c6-529e65515d78',
      type: 'class',
      name: 'Testimonial Quote Icon',
      comb: '',
      styleLess: 'margin-bottom: 24px;',
      children: [],
      variants: {
        tiny: {styleLess: 'width: 30px;'},
        small: {styleLess: 'width: 50px; margin-bottom: 16px;'},
      },
    },
    {
      _id: 'cce71f35-76a3-8ec1-93bd-80e834df5abe',
      type: 'class',
      name: 'Testimonial Quote',
      comb: '',
      styleLess:
        'margin-bottom: 32px; font-size: 24px; line-height: 32px; font-weight: 600;',
      children: [],
      variants: {
        medium: {styleLess: 'overflow: visible;'},
        tiny: {styleLess: 'font-size: 22px; line-height: 30px;'},
      },
    },
    {
      _id: 'c45069b3-fc3f-b87d-4ce4-6617c9174f38',
      type: 'class',
      name: 'Testimonial Info Two',
      comb: '',
      styleLess: 'display: flex; align-items: center;',
      children: [],
      variants: {},
    },
    {
      _id: 'eee554db-e006-8dc8-ae3d-0f25db8d5e13',
      type: 'class',
      name: 'Testimonial Image',
      comb: '',
      styleLess:
        'width: 60px; height: 60px; margin-right: 16px; border-top-left-radius: 50%; border-top-right-radius: 50%; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%; object-fit: cover;',
      children: ['ef5c9902-3a40-6a1b-9c7a-521d48c5e000'],
      variants: {},
    },
    {
      _id: '67a6bd26-47c6-6cd9-a2d9-4943d79f7131',
      type: 'class',
      name: 'Testimonial Author Name',
      comb: '',
      styleLess: 'font-weight: 700;',
      children: [],
      variants: {},
    },
    {
      _id: '51048331-6acb-a80d-2a7c-788e4ab28cdb',
      type: 'class',
      name: 'Testimonial Image Two',
      comb: '',
      styleLess: 'width: 350px; height: 400px; object-fit: cover;',
      children: [],
      variants: {small: {styleLess: 'width: 100%; height: auto;'}},
    },
    {
      _id: '343f9f95-7390-75b6-5465-86d52e0c6786',
      type: 'class',
      name: 'Testimonial Author Image Three',
      comb: '',
      styleLess:
        'width: 50px; height: 50px; margin-right: 24px; border-top-left-radius: 50%; border-top-right-radius: 50%; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%; object-fit: cover;',
      children: [],
      variants: {tiny: {styleLess: 'margin-right: 16px;'}},
    },
    {
      _id: 'b6d8f8f1-84db-70ec-8ae1-d309a3af6d67',
      type: 'class',
      name: 'Testimonial Slider Arrow',
      comb: '',
      styleLess: 'display: none;',
      children: [],
      variants: {},
    },
    {
      _id: '6919bf98-36ff-8d4d-a618-b341380a42ab',
      type: 'class',
      name: 'Testimonial Slider Nav',
      comb: '',
      styleLess:
        'position: static; bottom: -60px; margin-top: 24px; font-size: 10px;',
      children: [],
      variants: {},
    },
  ],
} as const;
